import React from "react";

// Vert = prêt à télécharger, bleu = en préparation, gris = demandé/expiré,
// rouge = échec.
const STATUT_BADGE_CLASS = {
  DEMANDE: "badge-secondary",
  EN_COURS: "badge-info",
  TERMINE: "badge-success",
  ECHEC: "badge-danger",
  EXPIRE: "badge-secondary",
};

/**
 * Badge de statut d'export, coloré selon le code renvoyé par l'API.
 * Le libellé affiché vient toujours de `statutLabel` (fourni par l'API).
 */
const StatutExportBadge = ({ statut, statutLabel }) => (
  <span
    className={"badge " + (STATUT_BADGE_CLASS[statut] || "badge-secondary")}
  >
    {statutLabel}
  </span>
);

export default StatutExportBadge;
